// Yup schemas for the sales domain. Mirrors BE Pydantic shapes in
// services/shared/shared_layer/schemas/sales.py.

import * as yup from "yup";

/**
 * POST /customer/sales/cancellation — cancel a customer sale.
 * Mirrors RequestCustomerSalesCancellation. The cancellation proof file is
 * handled outside RHF (multipart upload state lives in the component).
 */
export const cancellationSchema = yup.object({
  cancellationReason: yup
    .string()
    .trim()
    .required("Cancellation reason is required")
    .max(500, "Reason cannot exceed 500 characters"),
  refundAmount: yup
    .number()
    .typeError("Refund amount must be a number")
    .min(0, "Cannot be negative")
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
});

/**
 * Cost sheet line items + project-level adjustments. Lives in
 * CostSheetFormModal — used to set the per-property pricing snapshot that
 * drives downstream demand letters and agreements.
 */
export const costSheetSchema = yup.object({
  basePrice: yup
    .number()
    .typeError("Base price must be a number")
    .min(0, "Cannot be negative")
    .required("Base price is required"),
  floorRiseAmount: yup
    .number()
    .typeError("Floor rise must be a number")
    .min(0, "Cannot be negative")
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
  carParkingPrice: yup
    .number()
    .typeError("Car parking price must be a number")
    .min(0)
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
  amenitiesPrice: yup
    .number()
    .typeError("Amenities price must be a number")
    .min(0)
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
  stampDutyPercent: yup
    .number()
    .typeError("Stamp duty % must be a number")
    .min(0)
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
  gstPercent: yup
    .number()
    .typeError("GST % must be a number")
    .min(0)
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
  registrationPercent: yup
    .number()
    .typeError("Registration % must be a number")
    .min(0)
    .nullable()
    .transform((v, orig) => (orig === "" || orig == null ? null : v)),
});
